import { useContextSelector } from "use-context-selector";

import { IStore, StoreContext } from "../../store-context";
import { DealFormData, IFile, IUser } from "../../types";

export const useDealFormSectionIdSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.dealModule.form.data?.section_id);

export const useDealFormIdSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.dealModule.form.data?.id);

export const useDealFormFilesSelect = (): IFile[] | null =>
  useContextSelector(StoreContext, (store: IStore) => store.dealModule.form.data?.files || null);

export const useDealFormTitleSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.dealModule.form.data?.title);

export const useDealFormDescriptionSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.dealModule.form.data?.description || null);

export const useDealFormLastVisitSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.dealModule.form?.last_visit_time);

export const useDealFormDealIdSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.dealModule.form.data?.deal_id);

export const useDealFormGroupsSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.dealModule.form.data?.groups);

export const useDealFormKindSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.dealModule.form.data?.kind);

export const useDealFormRecurringDateSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.dealModule.form.data?.recurring_date);

export const useDealFormAiDataSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => {
    return { ai_files: store.dealModule.form.data?.ai_files, ai_status: store.dealModule.form.data?.ai_status };
  });

export const useDealFormLoadingSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.dealModule.form.loading);

export const useRequestRefreshDealFormSelect = () =>
  useContextSelector(StoreContext, (store: IStore) => store.dealModule.form.request_refresh);

export const useDealFormUserSelect = (userId: number): Partial<IUser> | undefined =>
  useContextSelector(StoreContext, (store: IStore) => {
    return store.dealModule.form.data?.users?.[userId];
  });

export const useDealFormUsersSelect = (): Array<Partial<IUser>> | undefined =>
  useContextSelector(StoreContext, (store: IStore) => {
    if (!store.dealModule.form.data?.users) {
      return;
    }
    return Object.values(store.dealModule.form.data.users);
  });

export const useDealFormDataSelect = (): DealFormData | null =>
  useContextSelector(StoreContext, (store: IStore) => {
    return store.dealModule.form.data;
  });
